import { createGmapVuePlugin } from '@gmap-vue/v3'
import type { IGmapVuePluginOptions } from '@gmap-vue/v3/dist/types/src/interfaces'
import '@gmap-vue/v3/dist/style.css'
import { type Plugin } from 'vue'

/**
 * Gmap docs: https://diegoazh.github.io/gmap-vue/docs/vue-3-version/
 * Plugin options: https://diegoazh.github.io/gmap-vue/docs/vue-3-version/api/gmap-vue-plugin
 */

const mapsOptions: IGmapVuePluginOptions = {
  load: {
    key: APP_ENV.VITE_APP_GMAP_KEY,
    mapIds: [APP_ENV.VITE_APP_GMAP_MAP_ID]
  }
}

// gmap-vue bundles its own Vue type path, which is structurally compatible at runtime
// but incompatible in TypeScript assignability checks with the app's Vue instance type.
export const maps = createGmapVuePlugin(mapsOptions) as unknown as Plugin
